import React, { Component } from 'react'
import { Row, Col, Select, Pagination } from 'antd'
import { app } from "../../app"

const Option = Select.Option

class PExperience extends Component {
    constructor (props) {
        super(props)
        this.state = {
            experiences: [
                { key: 'rescue', name: '救援经历' },
                { key: 'train', name: '培训经历' },
                { key: 'drill', name: '演练经历' },
                { key: 'socialService', name: '社会服务经历' },
                { key: 'donate', name: '捐赠记录' },
            ],
            years: [],
            dataList: [],
            page: 1,
            total: 0,
            data_loading: true,
        }
    }

    async componentDidMount () {
        this._isMounted = true
        let time = await app.getServerTime()
        await this.setData({years: [time.getFullYear() - 1, time.getFullYear()]})
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    render () {
        let { experiences, years, total, page } = this.state
        return (
            <div className="member-page experience">
                <div className="mp-content">
                    <div className="e-filter">
                        <Select placeholder="查看内容" style={{width: '10rem', marginRight: '1rem'}}>
                            {
                                experiences.map(e => {
                                    return (
                                        <Option key={e.key} value={e.key}>{e.name}</Option>
                                    )
                                })
                            }
                        </Select>
                        <Select placeholder="选择年份" style={{width: '8rem'}}>
                            {
                                years.map(y => {
                                    return (
                                        <Option key={y} value={y}>{y}</Option>
                                    )
                                })
                            }
                        </Select>
                    </div>
                    <div className="e-items">
                        <Row className="ei-item">
                            <Col span={14} className="name">11111111111111111111111111111111111111111111111111</Col>
                            <Col span={10} className="date">反倒是 ~ 手动阀</Col>
                        </Row>
                        <Row className="ei-item">
                            <Col span={14} className="name">11111111111111111111111111111111111111111111111111</Col>
                            <Col span={10} className="date">反倒是 ~ 手动阀</Col>
                        </Row>
                        <Row className="ei-item">
                            <Col span={14} className="name">11111111111111111111111111111111111111111111111111</Col>
                            <Col span={10} className="date">反倒是 ~ 手动阀</Col>
                        </Row>
                        <Row className="ei-item">
                            <Col span={14} className="name">11111111111111111111111111111111111111111111111111</Col>
                            <Col span={10} className="date">反倒是 ~ 手动阀</Col>
                        </Row>
                        <Row className="ei-item">
                            <Col span={14} className="name">11111111111111111111111111111111111111111111111111</Col>
                            <Col span={10} className="date">反倒是 ~ 手动阀</Col>
                        </Row>
                    </div>
                    <div className="e-page">
                        <Pagination current={page} size="small" total={total} hideOnSinglePage={false}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default PExperience



// WEBPACK FOOTER //
// ./src/routes/playerInfo/PExperience.jsx